/* TEAM MITHAI – My account page (sections/tm-account.liquid) */
(() => {
  if (customElements.get('tm-account')) return;
  customElements.define('tm-account', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const signal = this.events.signal;
      this.classList.add('is-enhanced');
      this.filter = 'all';
      this.query = '';

      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tma-tab]');
        if (tab) { event.preventDefault(); this.show(tab.dataset.tmaTab, true); return; }
        const filter = event.target.closest('[data-tma-filter]');
        if (filter) { this.filter = filter.dataset.tmaFilter; this.querySelectorAll('[data-tma-filter]').forEach(button => { const active = button === filter; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); }); this.applyFilters(); return; }
        const again = event.target.closest('[data-tma-buy-again]');
        if (again) this.buyAgain(again);
      }, { signal });
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-tma-search]')) return;
        this.query = event.target.value.replace(/[#\s]/g, '').toLowerCase();
        this.applyFilters();
      }, { signal });
      window.addEventListener('hashchange', () => this.show(location.hash.slice(1), false), { signal });

      this.show(location.hash.slice(1), false);
    }
    disconnectedCallback() { this.events?.abort(); }
    show(name, push) {
      const panels = [...this.querySelectorAll('[data-tma-panel]')];
      if (!panels.length) return;
      const target = panels.find(panel => panel.dataset.tmaPanel === name) ? name : 'orders';
      panels.forEach(panel => { panel.hidden = panel.dataset.tmaPanel !== target; });
      this.querySelectorAll('[data-tma-tab]').forEach(tab => {
        const active = tab.dataset.tmaTab === target;
        tab.classList.toggle('is-active', active);
        if (active) tab.setAttribute('aria-current', 'page'); else tab.removeAttribute('aria-current');
      });
      this.dataset.panel = target;
      if (push && location.hash.slice(1) !== target) history.replaceState(null, '', `#${target}`);
    }
    applyFilters() {
      let visible = 0;
      this.querySelectorAll('[data-tma-order]').forEach(order => {
        const statusOk = this.filter === 'all' || order.dataset.status === this.filter;
        const searchOk = !this.query || order.dataset.name.toLowerCase().includes(this.query);
        order.hidden = !(statusOk && searchOk);
        if (!order.hidden) visible += 1;
      });
      const empty = this.querySelector('[data-tma-no-match]');
      if (empty) empty.hidden = visible > 0;
    }
    async buyAgain(button) {
      if (button.disabled) return;
      let items = [];
      try { items = JSON.parse(button.dataset.items || '[]'); } catch (_) { items = []; }
      const label = button.dataset.label || button.textContent;
      button.dataset.label = label;
      if (!items.length) { button.textContent = this.dataset.unavailable; return; }
      button.disabled = true;
      button.textContent = this.dataset.adding;
      try {
        const base = this.dataset.cartAddUrl || '/cart/add';
        const response = await fetch(base.endsWith('.js') ? base : `${base}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error();
        button.textContent = this.dataset.added;
        const opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click(); else window.location.href = this.dataset.cartUrl || '/cart';
      } catch (_) {
        button.textContent = this.dataset.unavailable;
      }
      setTimeout(() => { button.disabled = false; button.textContent = label; }, 2200);
    }
  });
})();
